const openQuickShopModal = (product) => {
    console.log(product);
    const variantId = product?.variants?.[0]?.id;
  
//   $(".custom-tol-var").val(variantId);
//   $(".custom-prod-id").val(product.id);
//   $("#totstoy-form button").click();
   fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Accept": "application/json"
    },
    body: JSON.stringify({
      id: variantId,
      quantity: 1
    })
  })
}

const subscribeToQuickShopClick = () => {
    window.tolstoyWidget.subscribe(
        "tolstoy_spotlight_carousel_quick_shop_click",
        (o) => {
            o.product && o.product.handle ? openQuickShopModal(o.product) : console.error("Product handle is not available in the event");
        },
        { disableDefault: !0 },
    );
}

window.tolstoyWidget ? subscribeToQuickShopClick() : window.addEventListener("tolstoyWidgetReady", subscribeToQuickShopClick);